import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminUsers = {
  staffCreateSuccess: "考务人员创建成功",
  candidateCreateSuccess: "考生创建成功",
  createUserSuccess: "用户创建成功",
  userUpdated: "用户信息已更新",
  passwordReset: "密码已重置",
  accountLocked: "账号已锁定",
  accountUnlocked: "账号已解锁",
  candidateKickedOut: "已踢下线，账号登录状态已失效",
  importCompleted: "导入完成：请求 {requested}，新增 {created}，更新 {updated}",
  pageTitleStaff: "考务人员管理",
  pageSubtitleStaff: "集中管理考务人员账号、角色与权限分工。",
  pageTitleCandidate: "考生管理",
  pageSubtitleCandidate: "独立管理考生账号，支持创建、编辑状态和重置密码。",
  rolePermissionsPageTitle: "角色权限",
  rolePermissionsPageSubtitle: "查看考试后台角色目录与权限矩阵，作为多角色并集配置的当前口径。",
  pageTitleAll: "用户与角色",
  pageSubtitleAll: "统一管理考务人员与考生账号，逐步从种子账号过渡到可运营配置。",
  createStaff: "新建考务人员",
  createCandidate: "新建考生",
  createUser: "新建用户",
  totalStaff: "考务人员总数",
  totalCandidate: "考生总数",
  totalUsers: "用户总数",
  activeAccounts: "活跃账号",
  activeUsers: "活跃用户",
  lockedAccounts: "锁定账号",
  pendingPasswordChange: "待改密",
  availableRoles: "可选角色",
  createStaffDrawerTitle: "新建考务人员",
  createCandidateDrawerTitle: "新建考生",
  createUserDrawerTitle: "新建用户",
  editUserDrawerTitle: "编辑用户",
  editUserDrawerTitleWithId: "编辑用户 #{id}",
  resetPasswordDrawerTitle: "重置密码",
  resetPasswordDrawerTitleWithId: "重置密码 #{id}",
  resetPasswordResultTitle: "密码已重置",
  resetPasswordResultHint: "请保存以下登录信息，关闭后将不再展示该密码明文。",
  batchResetPasswordResultTitle: "批量重置密码结果",
  batchResetPasswordResultHint: "以下为本次成功重置的账号信息，请及时复制保存。",
  batchImportModalTitle: "批量导入考生（Excel）",
  importInvalidArray: "导入内容格式错误",
  importInvalidJson: "Excel 解析失败",
  importExample: "请使用模板文件导入",
  resetPasswordHelp: "将为 {username} 设置新的登录密码。",
  searchPlaceholder: "按用户名或姓名搜索",
  searchPlaceholderStaff: "按用户名或姓名搜索考务人员",
  searchPlaceholderCandidate: "按用户名或姓名搜索考生",
  summary: {
    totalUsers: "用户总数：{count}",
    activeUsers: "活跃用户：{count}",
    availableRoles: "可选角色：{count}",
  },
  table: {
    id: "ID",
    username: "用户名",
    fullName: "姓名",
    role: "角色",
    status: commonShortNouns.status,
    onlineStatus: "在线状态",
    phone: "手机号",
    idCardNo: "身份证",
    expiresAt: "到期时间",
    securityState: "安全状态",
    superuser: "超级管理员",
    lastLogin: "最近登录",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  fields: {
    avatarUrl: "头像 URL",
    phone: "手机号",
    idCardNo: "身份证号",
    expiresAt: "到期时间",
    expiresQuickDay: "1天",
    expiresQuickWeek: "1周",
    expiresQuickMonth: "1月",
    expiresQuickYear: "1年",
    initialPassword: "初始密码",
    newPassword: "新密码",
    loginAddress: "登录地址",
    temporaryPassword: "随机密码",
    status: commonShortNouns.status,
    superuser: "超级管理员",
  },
  actions: {
    batchImport: "批量导入",
    resetPassword: "重置密码",
    batchResetPassword: "批量重置密码({count})",
    batchClearAvatar: "批量清空头像({count})",
    batchLock: "批量锁定({count})",
    batchUnlock: "批量解锁({count})",
    clearAvatar: "清除头像",
    lock: "锁定",
    unlock: "解锁",
    impersonate: "附身登录",
    kickout: "踢下线",
  },
  labels: {
    superuserShort: "超管",
    online: "在线",
    offline: "离线",
    identitySourceSso: "统一身份",
    identitySourceLocalCandidate: "本地考生",
    identitySourceLocalStaff: "本地人员",
    linked: "已关联",
    unlinked: "未关联",
  },
  messages: {
    candidateCustomFieldsSaved: "考生自定义字段已保存",
    batchCustomFieldApplied: "批量设置完成：成功 {success}，失败 {failed}",
    batchLockCompleted: "批量锁定完成：成功 {success}，失败 {failed}",
    batchUnlockCompleted: "批量解锁完成：成功 {success}，失败 {failed}",
    batchClearAvatarCompleted: "批量清空头像完成：成功 {success}，失败 {failed}",
    batchResetPasswordCompleted: "批量重置密码完成：成功 {success}，失败 {failed}",
    batchCustomFieldValueRequired: "请至少配置一个字段值",
    selectExcelFileWarning: "请先选择 Excel 文件",
    ssoLinkSuccess: "已关联统一身份考生：{linked}/{requested}",
  },
  ssoSync: {
    searchPlaceholder: "按用户名搜索统一身份考生",
    action: "关联统一身份考生",
    staffAction: "关联统一身份人员",
    bindAction: "绑定统一身份",
    unbindAction: "解除关联",
    staffManagedTitle: "考务人员主数据已切换到统一身份",
    staffManagedDescription:
      "本页展示的是 sso-center 的人员主数据。新增、编辑、重置密码、锁定等操作请前往平台后台的“身份与权限”维护。",
    modalTitle: "关联统一身份考生",
    modalSubmit: "关联已选",
    modalAlertTitle: "从统一身份关联考生",
    modalAlertDescription:
      "只关联统一身份中的 candidate 用户。认证仍由统一身份负责，考试侧只保留考生业务档案和考试关系。",
    bindModalTitle: "绑定统一身份到本地用户：{username}",
    bindModalSubmit: "确认绑定",
    bindModalAlertTitle: "将本地用户绑定到统一身份",
    bindModalAlertDescription:
      "绑定后，后续统一身份登录会优先命中这个本地业务用户，不再仅依赖用户名匹配。",
    unbindConfirmTitle: "解除统一身份关联",
    unbindConfirmDescription:
      "解除后，本地用户 {username} 不再绑定统一身份账号，后续统一身份登录也不会再命中这个本地业务用户。",
    staffModalTitle: "关联统一身份人员",
    staffModalSubmit: "关联并分配角色",
    staffModalAlertTitle: "从统一身份关联考务人员",
    staffModalAlertDescription:
      "从统一身份选择人员后，可一次分配多个本地业务角色。统一身份只负责账号与基础身份，exam 只维护自己的业务角色与权限并集。",
    remoteRole: "统一身份角色",
    linkedStatus: "关联状态",
    identitySource: "来源",
    bindingSummary: "绑定关系",
    ssoBoundWithId: "已绑定 SSO #{id}",
    linkedToLocalUser: "已绑定到本地用户：{username}",
    linkedToLocalUserWithRole: "已绑定到本地用户：{username}（{role}）",
    localOnly: "仅本地",
    staffLinkSuccess: "已关联统一身份人员：{linked}/{requested}",
    bindSuccess: "统一身份绑定已保存",
    unbindSuccess: "统一身份关联已解除",
  },
  importDialog: {
    templateDownload: "下载模板",
    validatePreview: "校验并预览",
    confirmImport: "确认导入",
    instruction: "先下载模板，按列填写后上传校验。仅“无错误”行会在确认后入库。",
    selectFile: "选择 Excel 文件",
    selectedFile: "已选择：{name}",
    summary: "共 {requested} 行：可导入 {valid} 行，错误 {invalid} 行",
    rowNumber: "行号",
    action: "动作",
    actionUpdate: "更新",
    actionCreate: "新建",
    errors: "错误",
    pass: "通过",
  },
  customFields: {
    action: "自定义字段",
    batchAction: "批量设置字段({count})",
    dialogTitle: "考生自定义字段",
    batchDialogTitle: "批量设置考生自定义字段（已选 {count} 人）",
    preview: "预校验",
    apply: "确认执行",
    instruction: "先选择要设置的字段并填写值，再执行预校验；确认后才会真正写入。",
    targetFields: "目标字段",
    targetFieldsPlaceholder: "选择需要批量设置的字段",
    emptyHint: "请选择字段后填写对应值。",
    previewSummary: "校验结果：请求 {requested}，通过 {success}，失败 {failed}",
    candidateId: "考生ID",
    result: "结果",
    reason: "原因",
    pass: "通过",
    fail: "失败",
  },
  confirm: {
    kickoutTitle: "确认踢下线该账号？",
    kickoutDescription: "踢下线后，该账号当前登录态会立即失效，需要重新登录。",
    resetPasswordTitle: "确认重置密码？",
    resetPasswordDescription: "将为 {username} 生成随机新密码并使其当前登录态失效。",
    batchLockTitle: "确认批量锁定？",
    batchLockDescription: "将锁定已选 {count} 名考生账号，并使其当前登录态失效。",
    batchUnlockTitle: "确认批量解锁？",
    batchUnlockDescription: "将解除已选 {count} 名考生账号的锁定状态。",
    batchClearAvatarTitle: "确认批量清空头像？",
    batchClearAvatarDescription: "将清空已选 {count} 名考生的头像。",
    batchResetPasswordTitle: "确认批量重置密码？",
    batchResetPasswordDescription: "将为已选 {count} 名考生生成随机新密码，并使其当前登录态失效。",
  },
};
